import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ServiceSchedule } from 'src/services/api-services/api-interfaces/api-interface-service-schedule';
import { CustomSchedule } from 'src/services/api-services/api-interfaces/custom-schedule.interface';
import { Scheduler } from 'src/services/api-services/api-interfaces/scheduler.interface';
import { HelperService } from 'src/services/helperService';
import { APICustomScheduleService } from 'src/services/api-services/api-custom-schedule-service';
import { APISchedulerService } from 'src/services/api-services/api-scheduler-service';
import { MatDialog as MatDialog } from '@angular/material/dialog';

import { VehicleData } from 'src/services/api-services/api-interfaces/vehicleData.interface';
import { APIcityService } from 'src/services/api-services/api-city-service';
import { EMPTY, Subscription, catchError, tap } from 'rxjs';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { LookAndFeelWebView } from 'src/models/LookAndFeelWebView';
import { ActivatedRoute, Router } from '@angular/router';
import { PublicSiteConfig } from 'src/services/publicSiteConfig.service';
import { ICancelAppointmentComponent } from './i-cancel-appointment/i-cancel-appointment.component';
import { IncadeaBookingService } from 'src/services/api-services/IncadeaBooking.service';
import { ResponseCompanies } from 'src/services/incadea/incadea-interfaces/responses/ResponseCompanies.interface';
import { incadeaChileConfig } from '../../../../services/incadeaChileConfig.service';
import { GetCompaniesService } from 'src/services/incadea/incadea-services/getCompanies.service';
import { InformationModalComponent } from 'src/app/WebView/FormWebView/query/consultant-form/information-modal/information-modal.component';
import { PublicSiteConfigBaseComponent } from 'src/app/base/publicSiteConfigBase.component';
import { ViewType } from 'src/app/enums/viewType.enum';
@Component({
    selector: 'app-i-consultant-appointment',
    templateUrl: './i-consultant-appointment.component.html',
    styleUrls: ['./i-consultant-appointment.component.sass'],
    standalone: false
})
export class IConsultantAppointmentComponent extends PublicSiteConfigBaseComponent implements OnInit {
  [x: string]: any;

  isAppointmentCanceled = false;
  canceledMessage: string = '';
  customerScheduleSubscribe?: Subscription;
  schedulerData: any[] = [];
  SchedulerDetailsResp: Scheduler[] = [];
  scheduleAttentionServiceResp: ServiceSchedule[] = [];
  customData!: CustomSchedule[];
  plateNumberSearch: string = '';
  public appointments: any[] = [];
  displayDate = new Date();
  public selectDate: Date = this.displayDate;
  customScheduleServiceResp: CustomSchedule[] = [];
  typeOfService: string = '';
  workshops: string[] = [];
  advisor: string[] = [];
  fecha: string[] = [];
  customScheduleResp: any[] = [];
  vehicleData: VehicleData[] = [];
  mileage;
  scheduleId: any;
  recievedLanguageForCountry: any = history.state.LanguageForCountry as {};
  utmParams:any = history.state.utmParams as {}
  receivedBackEndCode: any = history.state.BackEndCode as {};
  editScheduleUrl: string = '';
  public showMessageNotFound: boolean = false;
  imagen_banner: any;
  recievedTokenIncadea: any = history.state.tokenIncadea as {};
  receivedNameCountry: any = history.state.nameCountry as {};
  customerSchedules;
  customerSchedules$ 
  scheduledAppointments: any = [];
  scheduledAppointmentsNumber : number = 0;
  index: any[] = [];
  cityId?: number;
  results: any[] = [];
  subscriptionComplete: boolean = false;
  loadingSerchPlate: boolean = false;
  companies!: ResponseCompanies[];
  companiesSelect?: ResponseCompanies;
  currentPage: number = 1;
  receivedTokenIncadea: any = history.state.tokenIncadea as {};
  receivedParameterChile: any = history.state.onlyInchcapeRetail as {};
  areFiltersLoading: boolean = true;
  BrandsSelect :string=""
  diableDerco:boolean=false
  hasMoreAppointments: boolean = true
  visibleAppointments: any[] = []
  Brands: any = [
    {
        "Link": "",
        "Description": "Mazda"
    },
    {
        "Link": "",
        "Description": "Suzuki"
    },
    {
        "Link": this.incadeaChileConfig.adressDercoIncadea,
        "Description": "Renault"
    },
    {
        "Link": this.incadeaChileConfig.adressDercoIncadea,
        "Description": "Haval"
    },
    {
        "Link":this.incadeaChileConfig.adressDercoIncadea,
        "Description": "Greatwall"
    },
    {
        "Link": this.incadeaChileConfig.adressDercoIncadea,
        "Description": "Changan"
    },
    {
      "Link": this.incadeaChileConfig.adressDercoIncadea,
      "Description": "Jac"
    },
    {
      "Link": this.incadeaChileConfig.adressDercoIncadea,
      "Description": "Great Wall"
    }
  ];

  //This is the reactive form
  formValidation = this.formBuilder.group({
    company: [''],
    Brand: [''],
    document: [ '',{ validators: [Validators.required, Validators.minLength(5)],},],
    placa: ['', Validators.required],
  });

  get cedulaControl(): FormControl {
    return this.formValidation.get('document') as FormControl;
  }
  get placaControl(): FormControl {
    return this.formValidation.get('placa') as FormControl;
  }

  constructor(
    private formBuilder: FormBuilder,
    public getCompaniesService: GetCompaniesService,
    public helperService: HelperService,
    public customScheduleService: APICustomScheduleService,
    public schedulerService: APISchedulerService,
    public dialog: MatDialog,
   
    public cityServiceApi: APIcityService,
    private translate: TranslateService,
    public override publicSiteConfig: PublicSiteConfig,
    public incadeaChileConfig: incadeaChileConfig,
    public getCreateIncadeaBooking: IncadeaBookingService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    super(publicSiteConfig, ViewType.Incadea);
    if (!this.recievedCountryData) {
      this.route.params.subscribe((params) => {
        this.indexbrand = params['brand'];
        this.indexCountry = params['country'];
      });
      const bannermanagementURL = `WebView/i-bannerManage/${this.indexbrand}/${this.indexCountry}`;
      this.router.navigate([bannermanagementURL]);
    }
  }

  protected override afterConfigLoaded(): void {
    this.imagen_banner = this.CurrentBrand.imagen_banner2;
    this.editScheduleUrl = `/WebView/i-schedule-choose/${this.indexbrand}/${this.indexCountry}`;

    if(this.indexbrand === 8){this.diableDerco = true;
      document.documentElement.style.setProperty('--webview-reservationSlots', 'repeat(8, 12%)');
    }
    else{ document.documentElement.style.setProperty('--webview-reservationSlots', 'repeat(7, 14%)');}
    //validates that they are none of these marks and makes them appear enabled, otherwise they will appear disabled.
    if (
      !(
        (this.indexbrand === 4 ||
          this.indexbrand === 5 ||
          this.indexbrand === 6||
          this.indexbrand === 8) &&
        this.indexCountry === 3
      )
    ) {
      this.formValidation.get('document')!.enable();
      this.formValidation.get('placa')!.enable();
    } else {
      this.getCompanyDataFromService();
      this.formValidation.get('document')!.disable();
      this.formValidation.get('placa')!.disable();
    }
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.customerScheduleSubscribe?.unsubscribe();
  }

  filterBrand(Brand:any){

    if(Brand.Link !== ""){  window.top!.location.href= Brand.Link}
    else{
      this.diableDerco = false
      // this.emptyschedule.MakeName = Brand.Description
    }
  }

  //collects information about companies and makes specific adjustments according to the number of companies and country settings.
  getCompanyDataFromService() {
    //evaluate if another things are selected
    this.getCompaniesService
      .getCompanies(this.receivedTokenIncadea, this.receivedBackEndCode)
      .pipe(
        tap((Response) => {
          this.companies = Response;
          if (
            (Response.length === 1 && this.recievedCountryData !== '3') ||
            this.receivedParameterChile === '1'
          ) {
            this.companiesSelect = Response[0];
            if(this.recievedBrandData === "8"){
              Response[0].Description = "Derco Center Tabancura"
            }
          }

          if (
            this.recievedCountryData === '3' &&
            this.receivedParameterChile !== '1'
          ) {
            switch (this.recievedBrandData) {
              case '4':
                Response = Response.concat(this.incadeaChileConfig.arrayGeely);
                this.companies = Response;

                break;

              case '5':
                Response = Response.concat(this.incadeaChileConfig.arraySubaru);
                this.companies = Response;

                break;

              case '6':
                Response = Response.concat(this.incadeaChileConfig.arrayDfsk);
                this.companies = Response;

                break;
                case '8':
                  Response[0].Description = "Derco Center Tabancura"
                  Response = Response.concat(this.incadeaChileConfig.arrayDerco);
                  this.companies = Response;

                break;
            }
          }
          this.areFiltersLoading = false;
        })
      )
      .subscribe();
  }

  getPlaceholder(indexCountry: number): string {
    if (indexCountry === 3) {
      return 'RUT';
    } else if (indexCountry === 8) {
      return 'DocumentNo';
    } else {
      return 'ID';
    }
  }

  getPlatePlaceholder(indexCountry: number): string {
    if (indexCountry === 3) {
      return 'Patente';
    } else if (indexCountry === 8) {
      return 'LicensePlate';
    } else {
      return 'Plate';
    }
  }

  //Add third party companies which is burned data
  filterCompany(company: any) {
    //When the country is Chile (Id:"3"), the switch case redirects to the URL of each brand
    if (this.recievedCountryData === '3') {
      switch (this.recievedBrandData) {
        case '4':
          let filterCompanyGeely = this.incadeaChileConfig.arrayGeely.filter(
            (Response) => Response === company
          );
          if (filterCompanyGeely.length > 0) {
            window.top!.location.href =
              this.incadeaChileConfig.adressGeelyIncadea;
          }
          break;

        case '5':
          let filterCompanySubaru = this.incadeaChileConfig.arraySubaru.filter(
            (Response) => Response === company
          );
          if (filterCompanySubaru.length > 0) {
            window.top!.location.href =
              this.incadeaChileConfig.adressSubaruIncadea;
          }
          break;

        case '6':
          let filterCompanyDfsk = this.incadeaChileConfig.arrayDfsk.filter(
            (Response) => Response === company
          );
          if (filterCompanyDfsk.length > 0) {
            window.top!.location.href =
              this.incadeaChileConfig.adressDfskIncadea;
          }
          break;
          case "8":
          let filterCompanyDerco = this.incadeaChileConfig.arrayDerco.filter(Response=>Response === company)
          if(filterCompanyDerco.length > 0 ){
            window.top!.location.href= this.incadeaChileConfig.adressDercoIncadea
          }
        break;
      }

    }
    this.companiesSelect = company;

    this.formValidation.get('document')!.enable();
    this.formValidation.get('placa')!.enable();
  }

  onplateNumberSearchClick() {
    this.loadingSerchPlate = true;
    this.getCreateIncadeaBooking
      .getIBAppointment("1",
        String(this.formValidation.value.placa),String(this.currentPage),"20",
        String(this.formValidation.value.document)
      )
      .pipe(
        tap((response) => {
          if (response === null) {
            const translateTxtNotMatch =
              this.translate.instant('notMatchFound');
              this.helperService.showAlert =true
              this.helperService.typeAlert ="error"
              this.helperService.messageAlert =translateTxtNotMatch
            setTimeout(() => {
              this.helperService.showAlert =false

              }, 7000)
            this.loadingSerchPlate = false;
          } else {
            if (response.Appointment[0]) {
              response.Appointment.sort((a, b) => new Date(b.Start).getTime() - new Date(a.Start).getTime())
         
              this.scheduledAppointments = response.Appointment;
              this.scheduledAppointmentsNumber = this.scheduledAppointments.length
              this.visibleAppointments = [...this.scheduledAppointments];
              this.hasMoreAppointments = true;
              this.currentPage = 1;
              this.scheduledAppointments.forEach((element) => {
                let date = element.Start.split('T')[0];
                let time = element.Start.split('T')[1];
                let formatTime = moment(time, 'HH:mm:ss').format('hh:mm A.');
                let splitTime = formatTime.split(' ');
                let customFormat = `${splitTime[0]} ${splitTime[1][0]}.${splitTime[1][1]}.`;
                element.time = customFormat;
                element.startDate = moment(date, 'YYYY-MM-DD').format(
                  'DD/MM/YYYY'
                );
                element.consultedSchedule = true;
              });

              this.subscriptionComplete = true;
              this.loadingSerchPlate = false;
            } else {
              const translateTxtNotMatch =
                this.translate.instant('notMatchFound');
                this.helperService.showAlert =true
                this.helperService.typeAlert ="error"
                this.helperService.messageAlert =translateTxtNotMatch
                setTimeout(() => {
                  this.helperService.showAlert =false

                  }, 7000)
              this.loadingSerchPlate = false;
            }
          }
        })
      )
      .subscribe({
        error: (error) => {
          if(error.status === 401){
            const bannermanagementURL = `WebView/bannerManage/${this.indexbrand}/${this.indexCountry}`
            this.router.navigate([bannermanagementURL]);
            this.helperService.TokenBooking = ''
          }else{
            const translateTxtNotMatch = this.translate.instant('notMatchFound');
            this.helperService.showAlert =true
            this.helperService.typeAlert ="error"
            this.helperService.messageAlert =translateTxtNotMatch
            setTimeout(() => {
             this.helperService.showAlert =false

            }, 7000)
            this.loadingSerchPlate = false;
          }
        },
      });
  }

  fetchMoreAppointments() {
    this.currentPage++;
    this.loadingSerchPlate = true;
    this.customerSchedules$ = this.getCreateIncadeaBooking
        .getIBAppointment("1",
          String(this.formValidation.value.placa),String(this.currentPage),"20",
          String(this.formValidation.value.document)
        ).pipe(
      catchError((error: any) => {
        this.loadingSerchPlate = false;
        return EMPTY;
      })
    );

    this.customerScheduleSubscribe = this.customerSchedules$.subscribe({
      next: (response) => {
        if (!response || response.length === 0) {
          this.hasMoreAppointments = false;
          this.loadingSerchPlate = false;
          return;
        }

        response.Appointment.forEach((element) => {
          let date = element.Start.split('T')[0];
          let time = element.Start.split('T')[1];
          let formatTime = moment(time, 'HH:mm:ss').format('hh:mm A.');
          let splitTime = formatTime.split(' ');
          let customFormat = `${splitTime[0]} ${splitTime[1][0]}.${splitTime[1][1]}.`;

          element.time = customFormat;
          element.startDate = moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
          element.consultedSchedule = true;
        });
        
        this.scheduledAppointments.push(...response.Appointment);
        this.visibleAppointments.push(...response.Appointment);
        this.scheduledAppointmentsNumber = this.scheduledAppointments.length;
        this.loadingSerchPlate = false;

        if (response.Appointment.length < 20) {
          this.hasMoreAppointments = false;
        }
      }
    });
  }  

  editSchedule(scheduledAppointments: any): void {
    if (this.isDisabledAppointment(scheduledAppointments)) {
      this.openDialogInformation(scheduledAppointments);
      return;
    }
    const state = {
        schedule: scheduledAppointments,
          cityName: scheduledAppointments.department,
          brand: this.recievedBrandData[0],
          cityId: scheduledAppointments.cityId,
          country: this.indexCountry,
          LanguageForCountry: this.recievedLanguageForCountry,
          nameCountry: this.receivedNameCountry,
          tokenIncadea: this.recievedTokenIncadea,
          BackEndCode: this.receivedBackEndCode,
          onlyInchcapeRetail: this.receivedParameterChile,
          utmParams:this.utmParams
    }
    this.router.navigate([this.editScheduleUrl], {
      state,
    });
  }

  openDialogInformation(appointment): void {
    let  scheduleId:any = appointment.id;
    const dialogRef = this.dialog.open(InformationModalComponent, {
      width: '550px',
      data: scheduleId,
    });

    dialogRef.afterClosed().subscribe(result => {
      setTimeout(() => {
        const currentLanguage = this.translate.currentLang     
        const bannermanagementURL = `WebView/bannerManage/${this.indexbrand}/${this.indexCountry}/${currentLanguage}`
        this.router.navigate([bannermanagementURL]);  
      }, 7000);
    });
  }

  isDisabledAppointment(scheduledAppointment: any): boolean {
    const currentDate = new Date()
    const LimitDate = new Date(currentDate.getTime() + 5 * 60000);
    const dateAppointment = new Date(scheduledAppointment.Start)

    return dateAppointment <= LimitDate;
  }

  onClearClick() {
    this.formValidation.reset();
  }

  openDialog(appointment): void {
    if (this.isDisabledAppointment(appointment)) {
      this.openDialogInformation(appointment);
      return;
    }

    let scheduleId: any = appointment;

    const dialogRef = this.dialog.open(ICancelAppointmentComponent, {
      width: '550px',
      data: {
        scheduleId: scheduleId,
        recievedTokenIncadea: this.recievedTokenIncadea,
        BackEndCode: this.receivedBackEndCode,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'eliminado') {
        this.typeOfService = appointment.Services[0].ServiceName;
        this.isAppointmentCanceled = true;
        this.subscriptionComplete = false;
        this.scheduledAppointmentsNumber = this.scheduledAppointmentsNumber -1
        // this.scheduledAppointments= this.scheduledAppointments.filter(r =>  r.id !== appointment.id)
        setTimeout(() => {
          this.subscriptionComplete = true;
        }, 10);
        setTimeout(() => {
          const currentLanguage = this.translate.currentLang;
          const bannermanagementURL = `WebView/i-bannerManage/${this.indexbrand}/${this.indexCountry}/${currentLanguage}`;
          this.router.navigate([bannermanagementURL]);
        }, 5000);
      }
      if (result === 'No eliminado') {
        const translateTxtNotMatch = this.translate.instant('CancelFailedMsg');
        this.helperService.showAlert =true
        this.helperService.typeAlert ="error"
        this.helperService.messageAlert =translateTxtNotMatch
        setTimeout(() => {
          this.helperService.showAlert =false

          }, 7000)
        setTimeout(() => {
          const currentLanguage = this.translate.currentLang;
          const bannermanagementURL = `WebView/i-bannerManage/${this.indexbrand}/${this.indexCountry}/${currentLanguage}`;
          this.router.navigate([bannermanagementURL]);
        }, 2500);
      }
    });
  }
}
